import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { HttpClient } from '@angular/common/http';
import { combine } from 'src/app/shared/utilities/route';
import { Observable } from 'rxjs';
import { Agency } from 'src/app/credentialing/auto-assign/models/agency.model';
import { CredentialingSpecialist } from 'src/app/credentialing/auto-assign/models/credentialing-specialist.model';
import { PayloadAgency } from 'src/app/credentialing/auto-assign/models/payload-agency.model';
import { Recruiter } from 'src/app/credentialing/auto-assign/models/recriuter.model';
import { TravelCredentialingSpecialist } from 'src/app/credentialing/auto-assign/models/travel-credentialing-specialist.model';
import { PayloadTravel } from 'src/app/credentialing/auto-assign/models/payload-travel.model';
import { ActiveAutoAssignType } from 'src/app/credentialing/auto-assign/models/auto-assign-type.model';
import { AdminCredentialingSpecialist } from 'src/app/credentialing/auto-assign/models/admin-credentialing-specialist.model';
import { PerDiemSpecialist } from 'src/app/credentialing/auto-assign/models/per-diem-specialist.model';
import { PerDiemAssignmentRules } from 'src/app/credentialing/auto-assign/models/per-diem-assignment-rules.model';

@Injectable({
    providedIn: 'root'
})
export class AutoAssignService {
    private readonly _coreApiPath: string;

    constructor(@Inject(APP_CONFIG) private readonly _settings: Settings, private readonly _httpClient: HttpClient) {
        this._coreApiPath = combine(this._settings.coreAPIUrl, 'AyaNova/Credentialing/AutoAssign');
    }

    getUnassignedAgencies(): Observable<Agency[]> {
        return this._httpClient.get<Agency[]>(`${this._coreApiPath}/UnassignedAgencies`);
    }

    getUnassignedRecruiters(): Observable<Recruiter[]> {
        return this._httpClient.get<Recruiter[]>(
            `${combine(this._settings.coreAPIUrl, 'ayanova/credentialing/UnasignedRecruiters')}`
        );
    }

    getAgencyUsers(): Observable<CredentialingSpecialist[]> {
        return this._httpClient.get<CredentialingSpecialist[]>(`${this._coreApiPath}/AgencyCredentialingSpecialists`);
    }

    getTravelCredentialingSpecialists(): Observable<TravelCredentialingSpecialist[]> {
        return this._httpClient.get<TravelCredentialingSpecialist[]>(
            `${this._coreApiPath}/GetTravelCredentialingSpecialists`
        );
    }

    getTypes(): Observable<ActiveAutoAssignType[]> {
        return this._httpClient.get<ActiveAutoAssignType[]>(`${this._coreApiPath}/GetActiveAutoAssignTypes`);
    }

    getAdminSpecialists(): Observable<AdminCredentialingSpecialist[]> {
        return this._httpClient.get<AdminCredentialingSpecialist[]>(`${this._coreApiPath}/GetCredentialingSpecialists`);
    }

    updateAdminSpecialists(payload: AdminCredentialingSpecialist[]): Observable<unknown> {
        return this._httpClient.post<unknown>(`${this._coreApiPath}/UpdateCredentialingSpecialists`, payload);
    }

    saveAgencyUsers(specialists: PayloadAgency[]): Observable<unknown> {
        return this._httpClient.post<unknown>(`${this._coreApiPath}/AgencyCredentialingSpecialists`, specialists);
    }

    saveTravelUsers(specialists: PayloadTravel[]): Observable<unknown> {
        return this._httpClient.post<unknown>(
            `${combine(this._settings.coreAPIUrl, 'ayanova/credentialing/auto-assignments')}`,
            specialists
        );
    }

    getPerDiemRules(): Observable<PerDiemAssignmentRules[]> {
        return this._httpClient.get<PerDiemAssignmentRules[]>(`${this._coreApiPath}/PerDiemAssignmentRules`);
    }

    getPerDiemSpecialists(): Observable<PerDiemSpecialist[]> {
        return this._httpClient.get<PerDiemSpecialist[]>(`${this._coreApiPath}/PerDiemCredentialingSpecialists`);
    }

    updatePerDiemAssigment(data: PerDiemAssignmentRules[]): Observable<unknown> {
        return this._httpClient.post<unknown>(`${this._coreApiPath}/UpdatePerDiemAssignmentRules`, data);
    }
}
